/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/button-has-type */
import React, { Component } from 'react';
import {
  WingBlank, Carousel, Toast, Tabs, Modal,
} from 'antd-mobile';
import queryString from 'query-string';
import {
  // isSameDay,
  format,
} from 'date-fns';
import PropTypes from 'prop-types';
// import moment from 'moment';
import styles from './styles.module.less';
// import spokesman from '../../../public/images/spokesmans.png';
import Live from '../../../public/images/live.png';
import baoming from '../../../public/images/baoming.png';
import yanjing from '../../../public/images/yanjing.png';
import tixing from '../../../public/images/tixing.png';
import dianpu from '../../../public/images/dianpu.png';
import fenxiang from '../../../public/images/fenxiang.png';
import xgeren from '../../../public/images/xgeren.png';
import {
  getImAppId, getImOpenId, getLiveDetail, getCheckPhone,
} from '../../../service/chat-service';
import tools from '../../../utils/tools';
import SigUpModal from './sigUpModal';
import LoginModule from './LoginModule';
import WXShare from '../../../components/WxShare';

const PRICE_TYPE_EMU = {
  QUOTATION: 1, // 报价单
  PRICE: 2, // 一口价
  INTERVAL: 3, // 区间价格
  COMBINATION: 4, // 组合价
};

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

const defaultProps = {};

const tabs = [
  { title: '活动详情', sub: 0 },
  { title: '商品列表', sub: 1 },
];
function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector
   || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    // eslint-disable-next-line no-param-reassign
    el = el.parentElement;
  }
  return null;
}
/**
 * 报名页
 */
class signUp extends Component {
  constructor() {
    super();
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    this.state = {
      modeKey: null,
      liveDetail: {},
      signUpData: [],
      spData: [],
      liveType: null,
      signUpType: null,
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
      isShow: false,
      liveId: null,
      wxName: '',
      staffOpenId: queryString.parse(windowHref).staffOpenId || '',
      shareUserId: queryString.parse(windowHref).staffUserId || '',
      isRecord: queryString.parse(windowHref).isRecord || '',
      // streamName: queryString.parse(windowHref).streamName || '',
      Id: queryString.parse(windowHref).id || '',
      flag: false,
      showTime: '',
      visvilt: false,
      visvilt2: false,
      visvilt2Url: '',
      qxxWeChatUrl: '', // 趣销销公众号二维码
      pools: [], // 主播人
    };
  }

  componentDidMount() {
    document.title = '报名页';
    this.getLiveOpenId(); // 微信授权
    // this.getLiveDetailLiveInfo();//本地联调
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  handleChangeClose = (show, val) => {
    const openId = localStorage.getItem('openId');
    if (show) this.getLiveDetailLiveInfo(openId, 1);
    this.setState(
      {
        modeKey: false,
      },
      () => {
        if (val === '报名成功') {
          this.setState({
            visvilt: true,
          });
        }
      },
    );
  }

  /**
   * 直播前开启了报名
   */
  handleChangeOpen = (signUpType) => {
    if (signUpType !== 1) {
      this.setState({
        modeKey: 'sigUp',
      });
    }
  }

  /**
   * 获取详情
   * @param openId
   * @param getType
   */
  getLiveDetailLiveInfo = async (openId, getType = 1) => {
    const { shareUserId, Id, wxName } = this.state;
    const params = {
      openId, getType, wxName, shareUserId, id: Number(Id),
    };
    // const params = {//本地调试
    //   openId: '11111',
    //   getType,
    //   wxName: 'xbz',
    //   shareUserId: '2E9EC48A76B044CE8FD871CF4DF34850',
    //   id: 647,
    // };

    const { data, code } = await getLiveDetail(params);
    console.log(data, code);
    if (code === 10000) {
      console.log('xxaaa', data.liveInfo);
      this.setState(
        {
          liveDetail: data.liveInfo,
          qxxWeChatUrl: data.qxxWeChatUrl,
          signUpData: data.signUpData || [],
          spData: data.spData || [1],
          liveType: data.liveType,
          signUpType: data.signUpType,
          liveId: data.liveInfo.id,
          pools: data.pools,
          isShow: true,
          flag: true,
          // showTime: isSameDay(new Date(data.liveInfo.expectedStartTime),
          //   new Date(data.liveInfo.expectedEndTime))
          //   ? `${format(new Date(data.liveInfo.expectedStartTime), 'MM月DD日HH:mm')}
          // ~${format(new Date(data.liveInfo.expectedEndTime), 'HH:mm')}`
          //   : `${format(new Date(data.liveInfo.expectedStartTime), 'MM月DD日HH:mm')}
          // ~${format(new Date(data.liveInfo.expectedEndTime), 'MM月dd日HH:mm')}`,
        },
        () => {
          console.log('xxx');
          this.countFun();
        },
      );
    } else {
      Toast.show('获取详情失败');
    }
  }

  /**
   * 微信授权
   * @returns {Promise<void>}
   */
  getLiveOpenId = async () => {
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    const WXCode = queryString.parse(windowHref).code;
    if (!WXCode) {
      localStorage.clear();
      try {
        const { code, data, message } = await getImAppId();
        if (process.env.REACT_APP_API_ENV === 'local') {
          // 本地测试时不走微信验证
          this.getLiveDetailLiveInfo('oQd0LwJcSPgP7eYwSy38bUdb793A', 1);
        } else if (code === 10000) {
          window.location.href = tools.toWxth(data);
        } else {
          Toast.show(message || '获取微信 appId 失败');
        }
      } catch (e) {
        Toast.show('获取微信 appId 失败');
      }
    } else if (!localStorage.getItem('openId')) {
      try {
        const { code, data } = await getImOpenId(WXCode, 1);
        if (code === 10000) {
          localStorage.setItem('openId', data.openid);
          this.setState({
            wxName: data.nickname,
          });
          this.getLiveDetailLiveInfo(data.openid, 1);
        }
      } catch (e) {
        Toast.show(e);
      }
    } else {
      this.getLiveDetailLiveInfo(localStorage.getItem('openId'), 1);
    }
  }

  /**
   * 弹框
   * @returns {null}
   */
  renderModule = () => {
    const {
      modeKey, liveDetail, isRecord, shareUserId, liveId, liveType, staffOpenId,
    } = this.state;
    const { history } = this.props;
    let elementModule = null;
    if (modeKey === 'sigUp') {
      elementModule = (
        <SigUpModal
          history={history}
          liveDetail={liveDetail}
          liveType={liveType}
          isRecord={isRecord}
          Id={liveId}
          shareUserId={shareUserId}
          shareOpenId={staffOpenId}
          onClose={this.handleChangeClose}
        />
      );
    }
    if (modeKey === 'module') {
      elementModule = (
        <LoginModule
          history={history}
          liveDetail={liveDetail}
          liveType={liveType}
          isRecord={isRecord}
          liveId={liveId}
          shareUserId={shareUserId}
          onClose={this.handleChangeClose}
        />
      );
    }
    return elementModule;
  }

  /**
   * 弹幕
   * @returns {*}
   */
  renderSiginData = () => {
    const { signUpData } = this.state;
    return (
      <Carousel className="my-carousel" vertical dots={false} dragging={false} swiping={false} autoplay infinite>
        {signUpData.map((type) => (
          <div key={type}>
            <span className={styles.item}>{type}</span>
            {' '}
            <span className={styles.float}>已报名</span>
          </div>
        ))}
      </Carousel>
    );
  }

  /**
   * 库存
   */
  renderStockNum = (item) => {
    const { priceType, stockNum, specStockNum } = item;
    let priceString = '';
    switch (priceType) {
      case PRICE_TYPE_EMU.QUOTATION:
        priceString = null;
        break;
      case PRICE_TYPE_EMU.PRICE:
        priceString = stockNum;
        break;
      case PRICE_TYPE_EMU.COMBINATION:
        priceString = specStockNum;
        break;
      default:
        break;
    }
    return priceString;
  }

  /**
   * 价格
   * @param item
   * @returns {string}
   */
  renderPrice = (item) => {
    const {
      priceType, intervalPriceLeft, intervalPriceRight, price, specPrice,
    } = item;
    let priceString = '';
    switch (priceType) {
      case PRICE_TYPE_EMU.QUOTATION:
        priceString = <p>报价单</p>;
        break;
      case PRICE_TYPE_EMU.PRICE:
        priceString = price ? Number(price) / 100 : 0;
        break;
      case PRICE_TYPE_EMU.INTERVAL:
        priceString = `${intervalPriceLeft / 100}-${intervalPriceRight / 100}`;
        break;
      case PRICE_TYPE_EMU.COMBINATION:
        priceString = specPrice ? Number(specPrice) / 100 : 0;
        break;
      default:
        break;
    }
    return priceString;
  }

  handleChangeLink = (item) => {
    const { shareUserId, Id, liveDetail } = this.state;
    const { history } = this.props;
    history.push(
      `/productDetail?shareUserId=${shareUserId}&productId=${item.id}&streamName=${liveDetail.streamName}&liveId=${Id}`,
    );
  }

  renderOriginalPrice = (item) => {
    const { priceType, originalPrice, specOriginalPrice } = item;
    let priceString = '';
    switch (priceType) {
      case PRICE_TYPE_EMU.QUOTATION:
        priceString = <p>报价单</p>;
        break;
      case PRICE_TYPE_EMU.PRICE:
        priceString = originalPrice ? Number(originalPrice) / 100 : 0;
        break;
      case PRICE_TYPE_EMU.COMBINATION:
        priceString = specOriginalPrice ? Number(specOriginalPrice) / 100 : 0;
        break;
      default:
        break;
    }
    return priceString;
  }

  /**
   * 关联商品
   * @returns {*[]}
   */
  renderCommodityList = () => {
    const { spData } = this.state;
    return spData.map((item) => (
      <div key={item.productName} className={styles.bodyMain}>
        <div className={styles.bodyImage}>
          <div className={styles.ImageWidth}>
            <img style={{ height: '100%' }} src={item.imgUrl} alt="" />
          </div>
          <div style={{ float: 'right', marginLeft: 10 }}>
            <div className={styles.titleSize}>{item.productName}</div>
            <div className={styles.money}>
              ¥
              {this.renderPrice(item)}
              <span className={styles.discount}>
                ¥
                {this.renderOriginalPrice(item)}
              </span>
            </div>
          </div>
        </div>
        <div className={styles.seckill}>
          <div className={styles.seckillBox}>
            剩余
            <span className={styles.titleSpan} style={{ color: '#FF3737' }}>
              &nbsp;
              {this.renderStockNum(item)}
              &nbsp;
            </span>
            件
          </div>
          <div
            className={styles.seckillButton}
            onClick={this.handleChangeLink.bind(null, item)}
            role="button"
            tabIndex={0}
          >
            立即秒杀
          </div>
        </div>
      </div>
    ));
  }

  /**
   * 正在直播
   */
  handleChangeIsShow = async () => {
    const {
      liveDetail, isRecord, shareUserId, Id,
    } = this.state;
    console.log(shareUserId, 'XXX1');
    const { history } = this.props;
    const params = {
      openId: localStorage.getItem('openId') || '',
      streamName: liveDetail.streamName,
    };
    if (liveDetail.signUpType === 1) {
      try {
        const { data } = await getCheckPhone(params);
        if (data.openType === '1') {
          this.setState({
            modeKey: 'sigUp',
          });
        } else {
          history.push(
            `/liveRegistration?streamName=${liveDetail.streamName}&liveId=${Id}&isRecord=${isRecord}&shareUserId=${shareUserId}`,
          );
        }
      } catch (e) {
        // console.log(e);
      }
    } else {
      try {
        const { data } = await getCheckPhone(params);
        if (data.openType === '1') {
          this.setState({
            modeKey: 'module',
          });
        } else {
          history.push(
            `/liveRegistration?streamName=${liveDetail.streamName}&liveId=${Id}&isRecord=${isRecord}&shareUserId=${shareUserId}`,
          );
        }
      } catch (e) {
        // console.log(e);
      }
    }
  }

  /**
   * 观看回放
   * @returns {Promise<void>}
   */
  handleChangeClick = async () => {
    const { history } = this.props;
    const {
      liveDetail, isRecord, Id, shareUserId,
    } = this.state;
    console.log(shareUserId, 'XXX2');
    history.push(
      `/liveRegistration?streamName=${liveDetail.streamName}&liveId=${Id}&isRecord=${isRecord}&shareUserId=${shareUserId}`,
    );

    // const params = {
    //   openId: localStorage.getItem('openId') || '2E9EC48A76B044CE8FD871CF4DF34850',
    //   streamName: liveDetail.streamName,
    // };
    // try {
    //   const { data } = await getCheckPhone(params);
    //   if (data.openType === '1') {
    //     this.setState({
    //       modeKey: 'module',
    //     });
    //   } else {
    //   }
    // } catch (e) {
    //   // console.log(e);
    // }
  }

  /**
   * 倒计时
   */
  countFun = () => {
    const { liveDetail } = this.state;
    const to = Date.parse(new Date(liveDetail.expectedStartTime.replace(/-/g, '/')));
    const nowTime = Date.parse(new Date());
    let remaining = to - nowTime;
    this.timer = setInterval(() => {
      // 防止出现负数
      if (remaining > 1000) {
        remaining -= 1000;
        const day = Math.floor(remaining / 1000 / 3600 / 24);
        const hour = Math.floor((remaining / 1000 / 3600) % 24);
        const minute = Math.floor((remaining / 1000 / 60) % 60);
        const second = Math.floor((remaining / 1000) % 60);
        this.setState({
          day,
          hour: hour < 10 ? `0${hour}` : hour,
          minute: minute < 10 ? `0${minute}` : minute,
          second: second < 10 ? `0${second}` : second,
        });
      } else {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  close = () => {
    const { visvilt } = this.state;
    this.setState({
      visvilt: !visvilt,
    });
  }

  close2 = (value) => {
    const { visvilt2, visvilt2Url } = this.state;
    console.log(visvilt2Url, 'X');
    let url = '';
    if (value !== '') {
      if (value.qrCode) {
        url = value.qrCode;
      } else {
        url = value.instructorHead;
      }
    }
    this.setState({
      visvilt2: !visvilt2,
      visvilt2Url: url,
    });
  }

  onWrapTouchStart = (e) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = closest(e.target, '.am-modal-content');
    if (!pNode) {
      e.preventDefault();
    }
  }

  // 跳转分享页
  golink = (e) => {
    const { history } = this.props;
    const { liveDetail, shareUserId } = this.state;
    if (e === '分享') {
      history.push(`/shareLive?id=${liveDetail.id}&shareUserId=${shareUserId}`);
    } else if (e === '个人') {
      history.push(`/logistics?id=${liveDetail.id}`);
    } else {
      history.push(`/shop?companyCode=${liveDetail.companyCode}&shareUserId=${shareUserId}`);
    }
  }

  // right测固定人
  fixedZhuboren = () => {
    const { pools } = this.state;
    return pools.map((item) => (
      <button key={item.openId} className={styles.zTips} onClick={this.close2.bind(null, item)}>
        <img src={item.instructorHead} alt="" />
        <span>{item.instructorName}</span>
      </button>
    ));
  }

  render() {
    const {
      liveDetail,
      liveType,
      signUpType,
      shareUserId,
      isRecord,
      liveId,
      isShow,
      flag,
      signUpData,
      day,
      hour,
      minute,
      second,
      showTime,
      visvilt,
      visvilt2,
      visvilt2Url,
      qxxWeChatUrl,
    } = this.state;
    return (
      <div className={styles.main}>
        <div className={styles.background}>
          <div className={styles.header}>
            <WingBlank size="lg">
              {second !== 0 && liveType !== 1 ? (
                <div style={{ float: 'left', overflow: 'hidden' }}>
                  <div className={styles.headerTitle}>直播倒计时</div>
                  <div className={styles.headerTime}>
                    {day}
                    {' '}
                    <span className={styles.headerTimetext}>天</span>
                    {' '}
                    {hour}
                    :
                    {minute}
                    :
                    {second}
                  </div>
                </div>
              ) : null}
              {liveType === 1 && (
                <div style={{ float: 'left', overflow: 'hidden' }}>
                  <div className={styles.liveStatus}>
                    <div className={styles.liveStatusText}>直播中</div>
                  </div>
                </div>
              )}

              {signUpData.length > 0 && (
                <div style={{ float: 'right', overflow: 'hidden' }} className={styles.Rotation}>
                  {flag && this.renderSiginData()}
                </div>
              )}
            </WingBlank>
          </div>
          <button className={styles.Tips} onClick={this.close}>
            <img src={tixing} alt="" />
            <span>直播提醒</span>
          </button>
          <div className={styles.zhuborens}>{this.fixedZhuboren()}</div>
          <img src={liveDetail.livePicAddress} alt="" />
        </div>
        <Modal
          visible={visvilt}
          transparent
          closable
          maskClosable
          onClose={this.close}
          wrapProps={{ onTouchStart: this.onWrapTouchStart }}
        >
          <div style={{ height: 200 }}>
            <div className={styles.modalTit}>关注趣销销公众号</div>
            <div>直播通知 查订单</div>
            <div className={styles.modalImg}>
              <img src={qxxWeChatUrl} alt="" style={{ width: 100, height: 100 }} />
            </div>
            <div>长按识别图中二维码</div>
          </div>
        </Modal>
        <Modal
          visible={visvilt2}
          transparent
          closable
          maskClosable
          onClose={this.close2.bind(null, '')}
          wrapProps={{ onTouchStart: this.onWrapTouchStart }}
        >
          <img src={visvilt2Url} alt="" style={{ width: 150, height: 150, marginLeft: 40 }} />
        </Modal>
        <div className={styles.live}>
          <div className={styles.title}>
            <div className={styles.liveImage}>
              <img src={Live} alt="" />
            </div>
            <div className={styles.margin}>
              <span className={styles.titleText}>{liveDetail.liveName}</span>
            </div>
          </div>
          <div className={styles.border} />
          <div className={styles.liveTime}>
            <div style={{ width: '50%', marginLeft: 20 }}>
              <div className={styles.timeTitle}>直播时间</div>
              <h5 className={styles.timesText}>{showTime}</h5>
            </div>
            <div className={styles.borderTwo} style={{ display: !liveDetail.signUpType ? 'none' : 'block' }} />
            <div style={{ width: '50%', display: !liveDetail.signUpType ? 'none' : 'block' }}>
              <div className={styles.timeTitle}>活动时间</div>
              <h5 className={styles.timesText}>
                {Number(liveDetail.signUpType) === 1
                  ? `${format(new Date(liveDetail.activityStart), 'MM月DD日')}-${format(new Date(liveDetail.activityEnd), 'MM月DD日')}`
                  : null}
              </h5>
            </div>
          </div>
          <div className={styles.NumberOfPeople}>
            <div>
              <img src={baoming} alt="" />
              <span>
                报名人数&nbsp;|&nbsp;
                {liveDetail.signUpUser}
                人
              </span>
            </div>
            <div>
              <img src={yanjing} alt="" />
              <span>
                浏览人数&nbsp;|&nbsp;
                {liveDetail.browseNum}
                人
              </span>
            </div>
          </div>
        </div>

        <div>
          <Tabs tabs={tabs} initialPage={0}>
            <div
              style={{
                backgroundColor: '#fff',
                marginBottom: '60px',
              }}
            >
              <h5 className={styles.titledel}>11111</h5>
              <div
                className={styles.tbodydel}
                dangerouslySetInnerHTML={{ __html: liveDetail.liveDetails }}
              />
            </div>
            <div
              style={{
                backgroundColor: '#fff',
                marginBottom: '60px',
              }}
            >
              {this.renderCommodityList()}
            </div>
          </Tabs>
          {/**
       <div style={{marginLeft:20}}>
              <h3 className={styles.bodyTitle}>关联商品</h3>
          </div>
      */}
        </div>
        <div className={styles.footer}>
          <div className={styles.signUpflex}>
            <div className={styles.image}>
              <div role="button" tabIndex={0} onClick={this.golink.bind(null, '店铺')}>
                <img src={dianpu} alt="" />
                <span>店铺</span>
              </div>
              <div role="button" tabIndex={0} onClick={this.golink.bind(null, '个人')}>
                <img src={xgeren} alt="" />
                <span>个人</span>
              </div>
              <div role="button" tabIndex={0} onClick={this.golink.bind(null, '分享')}>
                <img src={fenxiang} alt="" />
                <span>分享</span>
              </div>
              {
                //  <img src={spokesman} alt="" />
              }
            </div>

            {liveType === 0 && Number(liveDetail.signUpType) === 1 && (
              <div
                className={styles.button}
                onClick={this.handleChangeOpen.bind(null, signUpType)}
                role="button"
                tabIndex={0}
              >
                {signUpType === 1 ? '已预约' : '马上报名'}
              </div>
            )}
            {liveType === 0 && liveDetail.signUpType === '0' && <div className={styles.button}>暂未开播</div>}
            {liveType === 1 && (
              <div className={styles.button} onClick={this.handleChangeIsShow} role="button" tabIndex={0}>
                进入直播间
              </div>
            )}
            {liveType === 4 && (
              <div className={styles.end} onClick={this.handleChangeClick} role="button" tabIndex={0}>
                进入回看
              </div>
            )}
          </div>
          {isShow && (
            <WXShare
              title={liveDetail.liveName}
              imgUrl={liveDetail.livePicAddress}
              desc={liveDetail.liveDetails}
              link={`${window.location.origin + window.location.pathname}?${encodeURIComponent(
                `streamName=${liveDetail.streamName}&liveId=${liveId}&staffUserId=${shareUserId}&isRecord=${isRecord}`,
              )}`}
            />
          )}
        </div>
        {this.renderModule()}
      </div>
    );
  }
}

signUp.propTypes = propTypes;
signUp.defaultProps = defaultProps;

export default signUp;
